import { mapGetters } from 'vuex';

export default {
  name: "CommaSeparatedSpan",

  props: {
    list: {
      type: Array,
      required: true
    },

    field: {
      type: String,
      required: true
    }
  },

  computed: {
    ...mapGetters([
      'isSuperUser',
    ]),
  },
}